import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Pool/filtrarAnalisis`, method: 'POST', body: values, token: token})
}
